import { useDispatch } from 'react-redux';
import './css/app.css'
import './css/main.css'
import './css/common.css'
import './css/payment.css'
import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom"
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, TotalAmountCount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import dayjs from 'dayjs';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchDateMonth, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from './component/search/search';
import { formatDateTime, changeNum } from './common/function';

function Settlement() {
    let navigate = useNavigate();
    const [loading, setLoading] = useState(true)
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(0)
    const [maxFirstPage, setMaxFirstPage] = useState(10)
    const [amount, setAmount] = useState([0, 0])

    const [listData, setListData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [clickData, setClickData] = useState([])
    const [reload, setReload] = useState(false)
    const [modal, setModal] = useState(false)
    const [modal1, setModal1] = useState(false)

    let dispatch = useDispatch()

    useEffect(() => {
        dispatch(change_Current_Location("정산내역"))
        dispatch(changeHeaderTitle({
            mainTitle: "정산내역",
            subTitle: ""
        }))
        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const handleChangeMaxPage = (event) => {
        setMaxFirstPage(Number(event.target.value));
    };

    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null); // Litepicker 인스턴스를 저장할 ref

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false, // 날짜 범위 선택
            format: 'YYYY/MM/DD', // 날짜 형식
            numberOfMonths: 2, // 두 달 표시
            numberOfColumns: 2, // 두 열로 나누어 표시
            showWeekNumbers: true, // 주 번호 표시
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                // 이벤트 리스너 등록
                picker.on('selected', (start, end) => {
                    setPreDate(start.format('YYYY/MM/DD'));
                    setNextDate(end.format('YYYY/MM/DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy(); // 컴포넌트 언마운트 시 파괴
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().startOf('month').format('YYYY/MM/DD'));
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY/MM/DD'));

    useEffect(() => {
        pickerRef.current?.setDateRange(preDate, nextDate);
    }, [])

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        setPage(1)
    };

    useEffect(() => {
        ListData()
    }, [page, maxFirstPage, preDate, nextDate])

    const ListData = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/settlement", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data?.settlement ?? [])
                setAmount([tmp?.data?.summary.total_amount ?? 0, tmp?.data?.summary.total_cancel_amount ?? 0])
                setTotalPage(tmp?.data?.pagination?.total ?? 0)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData = [
        // { "no": 1, "text": "NO", "width": "50px", "textAlign": "center" },
        { "no": 2, "text": "정산일", "width": "100px", "textAlign": "center" },
        { "no": 3, "text": "거래상태", "width": "100px", "textAlign": "center" },
        // { "no": 4, "text": "거래금액", "width": "100px", "textAlign": "center" },
        // { "no": 5, "text": "수수료율", "width": "100px", "textAlign": "center" },
        // { "no": 6, "text": "수수료", "width": "100px", "textAlign": "center" },
        { "no": 7, "text": "정산금", "width": "120px", "textAlign": "center" },
        // { "no": 8, "text": "결제구분", "width": "100px", "textAlign": "center" },
        // { "no": 9, "text": "구매자명", "width": "100px", "textAlign": "center" },
        // { "no": 10, "text": "상품명", "width": "150px", "textAlign": "center" },
        // { "no": 11, "text": "주문번호", "width": "150px", "textAlign": "center" },
        // { "no": 12, "text": "거래상세", "width": "80px", "textAlign": "center" },
    ];

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            let list = listData ?? []
            for (let i = 0; i < list.length; i++) {
                let data = list[i]

                tableBodyData.push([
                    // { "no": 1, "text": list.length - i, "width": "50px", "textAlign": "center" },
                    { "no": 2, "text": formatDateTime(data.trx_date), "width": "100px", "textAlign": "center" },
                    { "no": 3, "text": data.state === "1" ? "승인" : "매입 후 취소", "width": "100px", "textAlign": "center" },
                    // { "no": 4, "text": Number(data.amt).toLocaleString('ko-KR') + "원", "width": "100px", "textAlign": "right" },
                    // { "no": 5, "text": Number(data.fee_rate).toFixed(2) + "%", "width": "100px", "textAlign": "right" },
                    // { "no": 6, "text": Number(data.fee).toLocaleString('ko-KR') + "원", "width": "100px", "textAlign": "right" },
                    { "no": 7, "text": changeNum(Number(data.settlement_amt)), "width": "120px", "textAlign": "right" },
                    // { "no": 8, "text": data.payment_type, "width": "100px", "textAlign": "center" },
                    // { "no": 9, "text": data.quota === "00" ? "." : `${data.quota}개월`, "width": "100px", "textAlign": "center" },
                    // { "no": 10, "text": data.cancelTranDate ? formatDateTime(`${data.cancelTranDate}${data.cancelTranTime}`) : '', "width": "150px", "textAlign": "center" },
                    // { "no": 11, "text": data.order_id, "width": "150px", "textAlign": "center" },
                    // {
                    //     "no": 12,
                    //     "text": (
                    //         <div className='pointer list-text-center' onClick={() => { setClickData(data); setModal(true) }}>
                    //             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-archive w-4 h-4" style={{ color: "#0064ff" }}>
                    //                 <path d="M20 9v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9m16-5H4a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-10 9h4"></path>
                    //             </svg>
                    //         </div>
                    //     ),
                    //     "width": "80px",
                    //     "textAlign": "center"
                    // }
                ])
            }
            setCombineData(tableBodyData)
        }
    }, [listData]);

    const excelBtn = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/settlement", {
            withCredentials: true,
            params: {
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                excelData(tmp?.data?.settlement ?? [])
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const excelData = (exData) => {
        let arr = []

        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]
                console.log(t)

                try {
                    arr.push({
                        "NO": i + 1,
                        "거래일시": t.trx_date,
                        "취소일시": t.cancel_date,
                        "거래상태": t.txtType === "BILL" ? "승인" : "취소",
                        "거래금액": Number(t.amt) + "원",
                        "수수료율": Number(t.fee_rate).toFixed(2) + "%",
                        "수수료": Number(t.fee) + "원",
                        "부가세": Number(t.vat) + "원",
                        "정산금": Number(t.settlement_amt) + "원",
                        "결제서비스": t.payment_type,
                        "구매자명": t.buyer_nm,
                        "상품명": t.prd_nm,
                        "주문번호": t.order_id,
                        "거래번호": t.trx_id,
                    })
                } catch (error) {
                    console.log(error);
                }
            }
        }
        Excel(arr)
    }


    return (
        <div class="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <div class="paylist">
                <form id="tabulator-html-filter-form" class="xl:flex sm:mr-auto">
                    <div class="form_filter w-full">
                        <SearchDateMonth
                            type={"날짜"}
                            inputRef={inputRef}
                            setDateRange={setDateRange}
                            preDate={preDate}
                            nextDate={nextDate}
                        />
                    </div>
                </form>
                <div className="intro-y box p-5 mt-2">
                    {/* <div className="tabulator_sorting_wrap">
                        <DownloadBtn text={"엑셀 다운로드"} onClick={excelBtn} />
                        <CountSelect onChange={handleChangeMaxPage} maxFirstPage={maxFirstPage} />
                    </div> */}
                    <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end' }}>
                        <div className="input_wrap" style={{ background: "#d2e4fb" }}>
                            <label>합계 :</label>
                            <input id="tot_amt" type="text" className="form-control" value={changeNum(amount[0])} readonly="" disabled="" />
                        </div>
                    </div>

                    <List
                        tableHeaderData={tableHeaderData}
                        tableBodyData={totalPage ?? 0}
                        filter_tableBodyData={combineData}
                        page={page}
                        setPage={setPage}
                        maxFirstPage={maxFirstPage}
                        nonePage={false}
                    />
                </div>
            </div>
        </div>
    )
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = `거래내역`;

    const ws = XLSX.utils.aoa_to_sheet([
        [
            "NO", "거래일시", "취소일시", "거래상태", "거래금액", "수수료율", "수수료", "부가세", "정산금", "결제서비스", "구매자명", "상품명", "주문번호", "거래번호"
        ]
    ]);
    excelData.map((data) => {
        XLSX.utils.sheet_add_aoa(
            ws,
            [
                [
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.NO },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래일시 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.취소일시 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래상태 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래금액 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.수수료율 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.수수료 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.부가세 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.정산금 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.결제서비스 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.구매자명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.상품명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.주문번호 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래번호 }
                ]
            ],
            { origin: -1 }
        );
        ws['!cols'] = [
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 }
        ]
        return false;
    });
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelButter = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelButter], { type: excelFileType });
    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default Settlement;